<script lang="ts">
	import { type Snippet } from 'svelte'
	interface Props {
		label: string
		children?: Snippet
		class?: string
		icon?: string
		iconSize?: number
		fontSize?: string
		fontWeight?: string
	}

	let {
		label,
		children,
		class: className = '',
		icon,
		iconSize = 15,
		fontSize = 'sm',
		fontWeight = 'medium'
	}: Props = $props()

	let dropdownButton: HTMLButtonElement | undefined = $state()
	let isOpen = $state(false)

	const onclick = () => {
		isOpen = !isOpen
	}

	const onWindowClick = (event: MouseEvent) => {
		if (
			isOpen &&
			!dropdownButton?.contains(event.target as Node) // Checks if the click is outside the dropdown
		) {
			isOpen = false
		}
	}
</script>

<svelte:window onclick={onWindowClick} />

<span class="{className} tw:relative">
	<button
		{onclick}
		bind:this={dropdownButton}
		type="button"
		aria-haspopup="menu"
		aria-expanded={isOpen}
		class="tw:hover:text-orange-500 tw:p-2 tw:border-0 tw:bg-transparent tw:inline-flex tw:items-center tw:gap-1 tw:text-plum">
		{#if icon}
			<svg width={iconSize} height={iconSize} role="img">
				<title>Dropdown icon</title>
				<use href="/images/icons/icons.svg#{icon}" />
			</svg>
		{/if}
		<span class="tw:text-{fontSize} tw:font-{fontWeight}">{label}</span>
		<svg width="16" height="16" role="img">
			<title>Activate dropdown</title>
			<use href="/images/icons/icons.svg#caretDownSolid" />
		</svg>
	</button>

	<div
		class="tw:absolute tw:right-0 tw:z-10 tw:mt-1 tw:w-40 tw:origin-top-right tw:rounded-md tw:bg-white tw:py-1 tw:ring-1 tw:shadow-lg tw:ring-black/5 tw:focus:outline-hidden"
		class:tw:hidden={!isOpen}
		role="menu"
		aria-orientation="vertical"
		aria-labelledby="user-menu-button"
		tabindex="-1">
		<div class="tw:py-1 tw:*:!no-underline" role="none">
			{@render children?.()}
		</div>
	</div>
</span>
